import {
    ReviewQuery as SourceReviewQuery
} from 'SourceQuery/Review.query';
import { Field } from 'Util/Query';

/** @namespace PeggysagePwa/Query/Review/Query */
export class ReviewQuery extends SourceReviewQuery {
    getAddPageReviewMutation(reviewItem) {
        return new Field('createPageReview')
            .setAlias('addPageReview')
            .addArgument('input', 'CreatePageReviewInput!', reviewItem)
            .addField(new Field('review').addField('nickname'));
    }

    /**
     * Override: add product_types
     * @returns {(Field|*)[]}
     * @private
     */
    _getRatingItemsFields() {
        return [
            ...super._getRatingItemsFields(),
            'product_types'
        ];
    }
}

export default new ReviewQuery();
